import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {InitBackpainTrackerPage} from "../init-backpain-tracker/init-backpain-tracker";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";

/**
 * Generated class for the InitMoodTrackerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-mood-tracker',
  templateUrl: 'init-mood-tracker.html',
})
export class InitMoodTrackerPage {
  nextHref: any = InitBackpainTrackerPage

  constructor(public navCtrl: NavController, public navParams: NavParams, public initWizard: InitWizardProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitMoodTrackerPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/init-mood-tracker/init-mood-tracker.ts